import { emitSustainabilityLabelClickEvent } from './eventEmitter';

export default ({ variationId, tableType, sustainabilityTag }) => {
  emitSustainabilityLabelClickEvent({
    product_VariationId: variationId,
    product_SustainabilityFeature: tableType,
    product_SustainabilityTags: sustainabilityTag.toLowerCase(),
    product_SustainabilityActivity: 'click'
  });
};
